<h1>Admin Main Menu</h1>
<mat-divider></mat-divider>

<div class="flex flex-wrap justify-center gap-[20px] mt-[100px] min-w-[300px]">
    <button mat-raised-button type="button" routerLink="/applicant-list">Applicant List</button>
    <button mat-raised-button routerLink="/scholarship-list">Scholarships List</button>
    <button mat-raised-button routerLink="/scholarship-count">Scholarship Count</button>
    <button mat-raised-button routerLink="/reports">Reports</button>
    <button mat-raised-button routerLink="/instructions">Instructions</button>
</div>

<div class="flex justify-center items-center mt-[100px] h-[48px]">
    <mat-icon>settings</mat-icon>
    <span>PEF Application Settings</span>
</div>
@if (loading === false) {
<div class="flex flex-col items-center">
    <div class="setting" matTooltip="{{schoolYearAdmin.Tooltip}}">
        <div>{{schoolYearAdmin.Label}}</div>
        <div class="value">{{schoolYearAdmin.Value | schoolYear}}</div>
    </div>
    <div class="setting" matTooltip="{{schoolYearStudent.Tooltip}}">
        <div>{{schoolYearStudent.Label}}</div>
        <div class="value">{{schoolYearStudent.Value | schoolYear}}</div>
    </div>
    <div class="setting" matTooltip="{{startDate.Tooltip}}">
        <div>{{startDate.Label}}</div>
        <div class="value">{{startDate.Value | date: 'MMM d y h:mmaaa'}}</div>
    </div>
    <div class="setting" matTooltip="{{endDate.Tooltip}}">
        <div>{{endDate.Label}}</div>
        <div class="value">{{endDate.Value | date: 'MMM d y h:mmaaa'}}</div>
    </div>
    <div class="setting" matTooltip="{{endDateDisplay.Tooltip}}">
        <div>{{endDateDisplay.Label}}</div>
        <div class="value">{{endDateDisplay.Value}}</div>
    </div>
</div>
}